<template>
  <section>
    <div>
      <!--<el-button type="text" @click="centerDialogVisible = true">点击打开 Dialog</el-button>-->
      <div class="feedback">
        <div
          v-if="false"
          class="button-div"
          @click="backtop()"
        >
          <div class="top_img"></div>
        </div>
        <!-- 公众号 -->
        <el-popover
          placement="left"
          :width="getLange === 'en' ? 170 : 140"
          trigger="hover"
          v-if="ip_isCn">
          <!-- 显示公众号二维码 -->
          <div class="feedback-hover">
            <img :src="require('../../assets/index/qrCode1.svg')">
            <p class="fst">{{$t('_7E461A1085F629F3')}}</p>
            <p class="snd">{{$t('_1D6BC498A0AD979C')}}</p>
          </div>
          <!-- 按钮 -->
          <div slot="reference" class="button-div">
            <div class="feedback-tab-img">
              <img :src="require('@/assets/index/qrCode.svg')">
            </div>
            <div class="feedback-tab-txt">
              {{$t('_7005434934422454')}}
            </div>
          </div>
        </el-popover>
        <!-- 我的收藏 -->
        <div
          class="button-div"
          @click="goCollection"
        >
          <div class="feedback-tab-img">
            <img :src="require('@/assets/index/if_like.svg')">
          </div>
          <div class="feedback-tab-txt">
            {{$t('D474')}}
          </div>
        </div>
        <!-- 在线客服 -->
        <a
          class="button-div"
          href='tencent://message/?uin=2230259928&Site=&Menu=yes'
        >
          <div class="feedback-tab-img">
            <img :src="require('@/assets/index/if_online.svg')">
          </div>
          <div class="feedback-tab-txt">
            {{$t('D475')}}
          </div>
        </a>
        <!-- 意见反馈 -->
        <div
          class="button-div"
          @click="DialogVisible()"
        >
          <div class="feedback-tab-img">
            <img :src="require('@/assets/member/feedback_l.svg')">
          </div>
          <div class="feedback-tab-txt">
            {{$t('_D483F385C3B31538')}}
          </div>
        </div>
        <!-- 回到顶部 -->
        <div class="gotop button-div" @click="backtop">
          <div class="feedback-tab-img">
            <img :src="require('@/assets/member/back_top.svg')">
          </div>
          <div class="feedback-tab-txt">
            {{$t('D349')}}
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('D350')"
      :visible.sync="centerDialogVisible"
      width="610px"
      center
    >
      <span>{{$t('D351')}}（{{$t('_5FF8D4C1679F272E')}}）</span>
      <div style="margin: 10px 0;"></div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 8, maxRows: 12}"
        :placeholder="$t('D352')"
        v-model="content"
      >
      </el-input>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="submit()"
        >{{$t('D191')}}</el-button>
        <el-button @click="centerDialogVisible = false">{{$t('SEARCH_05')}}</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
  import { FeedbackSubmit } from '../../api/api'
  import connectMixin from '@/mixin/connectMixin'

  export default {
    name: 'Feedback',
    mixins: [connectMixin],
    data() {
      return {
        content: '',
        centerDialogVisible: false,
        ip_isCn: false
      }
    },
    computed: {
      isVisitor() {
        return !this.$store.state.token ? true : false
      },
      getLange(){
        return this.$store.state.language
      }
    },
    methods: {
      goCollection () {
        if (this.isVisitor == true) {
          this.$emit('loGin', 1)
        } else {
          this.$router.push('/user_central/person')
        }
      },
      DialogVisible() {
        if (this.isVisitor == true) {
          this.$emit('loGin', 1)
        } else {
          this.centerDialogVisible = true
          this.content = ''
        }
      },
      backtop() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
      },
      submit() {
        if (this.content.length < 5) {
          this.$message({
            message: this.$t('_82725C780D821B2D'),
            type: 'warning',
          })
          return
        }
        FeedbackSubmit({ content: this.content })
          .then(res => {
            if (res.data.ret !== 0) {
              this.$message({
                message: this.$t(res.data.msg),
                type: 'warning',
              })
            } else {
              this.$message({
                // message: this.$t(res.data.msg),
                showClose: true,
                message: this.$t('D353'),
                type: 'success',
              })
              this.centerDialogVisible = false
              if (window.ga) {
                ga('send', 'event', '用户', '用户反馈', '用户')
              }
            }
          })
          .catch(function(error) {
            console.log('发生错误！', error)
          })
      },
      getIp() {
        let ip_isCn
        let tm = setInterval(() => {
          ip_isCn = window.sessionStorage.getItem('ip_isCn')
          if (ip_isCn !== null) {
            this.ip_isCn = JSON.parse(ip_isCn)
            clearInterval(tm)
            tm=null
          }
        }, 100)
      }
    },
    mounted() {
      this.getIp()
    }
  }
</script>
<style lang="less">
  .feedback {
    width: 64px;
    position: fixed;
    right: 20px;
    bottom: 130px;
    z-index: 999;
    border-radius: 4px;
    background: #ffffff;
    box-shadow:0px 3px 6px rgba(0,0,0,0.16);
    .feedback-tab-img {
      opacity: 0.66;
      padding: 16px 23px 8px;
      img {
        height: 21px;
        width: 21px;
      }
    }
    .feedback-tab-txt {
      font-size:11px;
      line-height:16px;
      color: #666;
      padding-bottom: 6px;
    }
    span {
      font-size: 12px;
      letter-spacing: 0;
      display: block;
      width: 100%;
    }
    .button-div {
      cursor: pointer;
      text-align: center;
      &:hover {
        background-color: #f1f1ff;
        .feedback-tab-txt {
          color: #005CAF;
        }
      }
    }
    .gotop {
      position: absolute;
      bottom: -63px;
      z-index: 99999;
      .feedback-tab-txt {
        color: #005CAF;
      }
      .feedback-tab-img {
        padding: 8px 23px 0;
      }
      background-color: transparent;
      &:hover {
        background-color: transparent;
      }
    }
  }

  .feedback-hover {
    text-align: center;
    img {
      width: 105px;
      height: 105px;
    }
    p {
      color: #005CAF;
    }
    .fst {
      font-size: 16px;
    }
    .snd {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// feedback.vue?ba5d4822